import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Checkbox,
  Select, notification, Button,
  Tooltip,
} from 'antd';
import TenantActions from '@Actions/tenantActions';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../../../../hooks/useCheckPortrait';
import './style.scss';

const { Option } = Select;

// Constants
const purchaseAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'FROM_GRN_LINE', label: 'Line Level' },
  { value: 'FROM_GRN', label: 'Document Level' },
  // { value: 'SAME_AS_PRODUCT_GROUP', label: 'Same as Product Group' },
];

const voucherSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'DOC_LEVEL', label: 'Document Level' },
];
const purchaseDiscountAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'DO NOT PUSH TO TALLY', label: 'Do Not Push To Tally' },
  // { value: 'DOC_LEVEL', label: 'Document Leve' },
  // { value: 'SAME_AS_PRODUCT_GROUP', label: 'Same as Product Group' },
];
const purchaseRoundOffAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'DO NOT PUSH TO TALLY', label: 'Do Not Push To Tally' },
  // { value: 'DOC_LEVEL', label: 'Document Level' },
  // { value: 'SAME_AS_PRODUCT_GROUP', label: 'Same as Product Group' },
];
const purchaseFreightAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'DO NOT PUSH TO TALLY', label: 'Do Not Push To Tally' },
  // { value: 'DOC_LEVEL', label: 'Document Level' },
  // { value: 'SAME_AS_PRODUCT_GROUP', label: 'Same as Product Group' },
];
const salesAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'LINE_LEVEL', label: 'Line Level' },
  { value: 'DOC_LEVEL', label: 'Document Level' },
];

const salesDiscountAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'DO NOT PUSH TO TALLY', label: 'Do Not Push To Tally' },
  // { value: 'DOC_LEVEL', label: 'Document Level' },
];
const salesRoundOffAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'DO NOT PUSH TO TALLY', label: 'Do Not Push To Tally' },
  // { value: 'DOC_LEVEL', label: 'Document Level' },
];
const salesFreightAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'DO NOT PUSH TO TALLY', label: 'Do Not Push To Tally' },
  // { value: 'DOC_LEVEL', label: 'Document Level' },
];

// creditNote Accoutn Selection
const creditNoteAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'DOC_LEVEL', label: 'Document Level' },
];
const debitNoteAccountSelectionMethod = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'DOC_LEVEL', label: 'Document Level' },
];

const AccountSetup = ({
  user, getTenants, tallyConnection, connectTenantToTallyLocation,
  connectTenantToTallyLocationLoading, setStep, stepNumber, getTallyConnections, itId, isDrawer, setShowDrawer,
}) => {
  // Component local State Variables & function
  const [purchaseAccountName, setPurchaseAccountName] = useState('');
  const [purchaseVoucherName, setPurchaseVoucherName] = useState('');
  const [purchaseAccount, setPurchaseAccount] = useState('');
  const [purchaseVoucher, setPurchaseVoucher] = useState('');
  const [salesVoucher, setSalesVoucher] = useState('');
  const [salesVoucherName, setSalesVoucherName] = useState('');

  const [sellerOption, setSellerOption] = useState('');
  const [sellerAccount, setSellerAccount] = useState('');
  const [formSubmitted, setFormSubmitted] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [salesVoucherIntegration, setSalesVoucherIntegration] = useState(false);
  const [purchaseVoucherIntegration, setPurchaseVoucherIntegration] = useState(false);
  const [creditNoteVoucherIntegration, setCreditNoteVoucherIntegration] = useState(false);
  const [debitNoteVoucherIntegration, setDebitNoteVoucherIntegration] = useState(false);
  const [purchaseDiscountAccountName, setPurchaseDiscountAccountName] = useState('');
  const [purchaseDiscountAccount, setPurchaseDiscountAccount] = useState('');
  const [purchaseRoundOffAccountName, setPurchaseRoundOffAccountName] = useState('');
  const [purchaseRoundOffAccount, setPurchaseRoundOffAccount] = useState('');
  const [purchaseFreightAccountName, setPurchaseFreightAccountName] = useState('');
  const [purchaseFreightAccount, setPurchaseFreightAccount] = useState('');
  const [debitNoteAccountName, setDebitNoteAccountName] = useState('');
  const [debitNoteAccount, setDebitNoteAccount] = useState('');
  const [debitNoteDiscountAccountName, setDebitNoteDiscountAccountName] = useState('');
  const [debitNoteDiscountAccount, setDebitNoteDiscountAccount] = useState('');
  const [debitNoteRoundOffAccountName, setDebitNoteRoundOffAccountName] = useState('');
  const [debitNoteRoundOffAccount, setDebitNoteRoundOffAccount] = useState('');
  const [salesDiscountAccountName, setSalesDiscountAccountName] = useState('');
  const [salesDiscountAccount, setSalesDiscountAccount] = useState('');
  const [salesRoundOffAccountName, setSalesRoundOffAccountName] = useState('');
  const [salesRoundOffAccount, setSalesRoundOffAccount] = useState('');
  const [salesFreightAccountName, setSalesFreightAccountName] = useState('');
  const [salesFreightAccount, setSalesFreightAccount] = useState('');
  const [creditNoteAccountName, setCreditNoteAccountName] = useState('');
  const [creditNoteAccount, setCreditNoteAccount] = useState('');
  const [creditNoteDiscountAccountName, setCreditNoteDiscountAccountName] = useState('');
  const [creditNoteDiscountAccount, setCreditNoteDiscountAccount] = useState('');
  const [creditNoteRoundOffAccountName, setCreditNoteRoundOffAccountName] = useState('');
  const [creditNoteRoundOffAccount, setCreditNoteRoundOffAccount] = useState('');
  const [stockJournalVoucherIntegration, setStockJournalVoucherIntegration] = useState(false);
  const [createPurchaseProductInBaseUOM, setCreatePurchaseProductInBaseUOM] = useState();
  const [createSalesProductInBaseUOM, setCreateSalesProductInBaseUOM] = useState();
  const [useDocumentNumberAsReferenceNumberForInvoice, setUseDocumentNumberAsReferenceNumberForInvoice] = useState();
  const [useDocumentNumberAsReferenceNumberForBill, setUseDocumentNumberAsReferenceNumberForBill] = useState();
  const [useInvoiceDateAsVoucherDateInBills, setUseInvoiceDateAsVoucherDateInBills] = useState();

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const [data, setData] = useState({});
  const integrationTallyIdURL = Number(Helpers.getValueFromUrl('it_id') || itId);

  const purchaseOption = tallyConnection?.purchase_account_list || [];

  // Component Logical / Effect functions
  useEffect(() => {
    getTenants(1, '', true, user?.tenant_info?.org_id);
    getTallyConnections(user?.tenant_info?.org_id, (tallyData) => {
      const tallyConnectionsFilteredData = tallyData?.filter((connection) => connection?.it_id === integrationTallyIdURL);
      setData(tallyConnectionsFilteredData);
    });
  }, [tallyConnection]);

  useEffect(() => {
    if (data) {
      setPurchaseAccountName(data?.[0]?.purchase_account_name);
      setPurchaseVoucherName(data?.[0]?.purchase_voucher_type);
      setPurchaseVoucher(data?.[0]?.purchase_voucher_type_selection);
      setPurchaseAccount(data?.[0]?.purchase_account_selection);
      setSalesVoucherIntegration(data?.[0]?.sales_voucher_integration);
      setPurchaseVoucherIntegration(data?.[0]?.purchase_voucher_integration);
      setCreditNoteVoucherIntegration(data?.[0]?.credit_note_voucher_integration);
      setDebitNoteVoucherIntegration(data?.[0]?.debit_note_voucher_integration);
      setSellerOption(data?.[0]?.sales_account_name);
      setSellerAccount(data?.[0]?.sales_account_selection);
      setSalesVoucher(data?.[0]?.sales_voucher_type_selection);
      setSalesVoucherName(data?.[0]?.sales_voucher_type);
      setPurchaseDiscountAccountName(data?.[0]?.purchase_discount_account_name);
      setPurchaseDiscountAccount(data?.[0]?.purchase_discount_account_selection || 'DEFAULT');
      setPurchaseRoundOffAccountName(data?.[0]?.purchase_roundoff_account_name);
      setPurchaseRoundOffAccount(data?.[0]?.purchase_roundoff_account_selection || 'DEFAULT');
      setPurchaseFreightAccountName(data?.[0]?.purchase_freight_account_name);
      setPurchaseFreightAccount(data?.[0]?.purchase_freight_account_selection || 'DEFAULT');
      setSalesDiscountAccountName(data?.[0]?.sales_discount_account_name);
      setSalesDiscountAccount(data?.[0]?.sales_discount_account_selection || 'DEFAULT');
      setSalesRoundOffAccountName(data?.[0]?.sales_roundoff_account_name);
      setSalesRoundOffAccount(data?.[0]?.sales_roundoff_account_selection || 'DEFAULT');
      setSalesFreightAccountName(data?.[0]?.sales_freight_account_name);
      setSalesFreightAccount(data?.[0]?.sales_freight_account_selection || 'DEFAULT');
      setDebitNoteAccountName(data?.[0]?.debit_note_account_name);
      setDebitNoteAccount(data?.[0]?.debit_note_account_selection);
      setDebitNoteDiscountAccountName(data?.[0]?.debit_note_discount_account_name);
      setDebitNoteDiscountAccount(data?.[0]?.debit_note_discount_account_selection || 'DEFAULT');
      setDebitNoteRoundOffAccountName(data?.[0]?.debit_note_roundoff_account_name);
      setDebitNoteRoundOffAccount(data?.[0]?.debit_note_roundoff_account_selection || 'DEFAULT');
      setCreditNoteAccountName(data?.[0]?.credit_note_account_name);
      setCreditNoteAccount(data?.[0]?.credit_note_account_selection);
      setCreditNoteDiscountAccountName(data?.[0]?.credit_note_discount_account_name);
      setCreditNoteDiscountAccount(data?.[0]?.credit_note_discount_account_selection || 'DEFAULT');
      setCreditNoteRoundOffAccountName(data?.[0]?.credit_note_roundoff_account_name);
      setCreditNoteRoundOffAccount(data?.[0]?.credit_note_roundoff_account_selection || 'DEFAULT');
      setStockJournalVoucherIntegration(data?.[0]?.stock_journal_voucher_integration);
      setCreatePurchaseProductInBaseUOM(data?.[0]?.create_purchase_product_in_base_uom);
      setCreateSalesProductInBaseUOM(data?.[0]?.create_sales_product_in_base_uom);
      setUseDocumentNumberAsReferenceNumberForInvoice(data?.[0]?.use_document_number_as_reference_number);
      setUseDocumentNumberAsReferenceNumberForBill(data?.[0]?.use_document_number_as_reference_number_for_bill);
      setUseInvoiceDateAsVoucherDateInBills(data?.[0]?.use_invoice_date_as_voucher_date_in_bills);
    }
  }, [data, stepNumber]);

  // API call/ Submit functions
  const handleSubmit = () => {
    setFormSubmitted(true);

    const isPurchaseValid = !purchaseVoucherIntegration || (
      ((purchaseAccount === 'DEFAULT' && purchaseAccountName) || (purchaseAccount !== 'DEFAULT' && !purchaseAccountName))
      && ((purchaseDiscountAccount === 'DEFAULT' && purchaseDiscountAccountName) || (purchaseDiscountAccount !== 'DEFAULT' && !purchaseDiscountAccountName))
      && ((purchaseFreightAccount === 'DEFAULT' && purchaseFreightAccountName) || (purchaseFreightAccount !== 'DEFAULT' && !purchaseFreightAccountName))
      && ((purchaseRoundOffAccount === 'DEFAULT' && purchaseRoundOffAccountName) || (purchaseRoundOffAccount !== 'DEFAULT' && !purchaseRoundOffAccountName))
      && ((purchaseVoucher === 'DEFAULT' && purchaseVoucherName) || (purchaseVoucher !== 'DEFAULT' && !purchaseVoucherName))
    );

    const isSalesValid = !salesVoucherIntegration || (
      ((sellerAccount === 'DEFAULT' && sellerOption) || (sellerAccount !== 'DEFAULT' && !sellerOption))
      && ((salesDiscountAccount === 'DEFAULT' && salesDiscountAccountName) || (salesDiscountAccount !== 'DEFAULT' && !salesDiscountAccountName))
      && ((salesFreightAccount === 'DEFAULT' && salesFreightAccountName) || (salesFreightAccount !== 'DEFAULT' && !salesFreightAccountName))
      && ((salesRoundOffAccount === 'DEFAULT' && salesRoundOffAccountName) || (salesRoundOffAccount !== 'DEFAULT' && !salesRoundOffAccountName))
      && ((salesVoucher === 'DEFAULT' && salesVoucherName) || (salesVoucher !== 'DEFAULT' && !salesVoucherName))

    );

    const isCreditNoteValid = !creditNoteVoucherIntegration || (
      ((creditNoteAccount === 'DEFAULT' && creditNoteAccountName) || (creditNoteAccount !== 'DEFAULT' && !creditNoteAccountName))
      && ((creditNoteDiscountAccount === 'DEFAULT' && creditNoteDiscountAccountName) || (creditNoteDiscountAccount !== 'DEFAULT' && !creditNoteDiscountAccountName))
      && ((creditNoteRoundOffAccount === 'DEFAULT' && creditNoteRoundOffAccountName) || (creditNoteRoundOffAccount !== 'DEFAULT' && !creditNoteRoundOffAccountName))
    );

    const isDebitNoteValid = !debitNoteVoucherIntegration || (
      ((debitNoteAccount === 'DEFAULT' && debitNoteAccountName) || (debitNoteAccount !== 'DEFAULT' && !debitNoteAccountName))
      && ((debitNoteDiscountAccount === 'DEFAULT' && debitNoteDiscountAccountName) || (debitNoteDiscountAccount !== 'DEFAULT' && !debitNoteDiscountAccountName))
      && ((debitNoteRoundOffAccount === 'DEFAULT' && debitNoteRoundOffAccountName) || (debitNoteRoundOffAccount !== 'DEFAULT' && !debitNoteRoundOffAccountName))
    );

    const isValid = isPurchaseValid && isSalesValid && isCreditNoteValid && isDebitNoteValid;

    if (isValid) {
      const payload = {
        ...data[0],
        purchase_account_name: purchaseAccountName,
        purchase_account_selection: purchaseAccount,
        purchase_voucher_type: purchaseVoucherName,
        purchase_voucher_type_selection: purchaseVoucher,
        purchase_discount_account_name: purchaseDiscountAccountName,
        purchase_discount_account_selection: purchaseDiscountAccount,
        purchase_roundoff_account_name: purchaseRoundOffAccountName,
        purchase_roundoff_account_selection: purchaseRoundOffAccount,
        purchase_freight_account_name: purchaseFreightAccountName,
        purchase_freight_account_selection: purchaseFreightAccount,
        sales_account_name: sellerOption,
        sales_account_selection: sellerAccount,
        sales_voucher_type: salesVoucherName,
        sales_voucher_type_selection: salesVoucher,
        sales_discount_account_name: salesDiscountAccountName,
        sales_discount_account_selection: salesDiscountAccount,
        sales_roundoff_account_name: salesRoundOffAccountName,
        sales_roundoff_account_selection: salesRoundOffAccount,
        sales_freight_account_name: salesFreightAccountName,
        sales_freight_account_selection: salesFreightAccount,
        purchase_voucher_integration: purchaseVoucherIntegration || false,
        sales_voucher_integration: salesVoucherIntegration || false,
        credit_note_voucher_integration: creditNoteVoucherIntegration || false,
        debit_note_voucher_integration: debitNoteVoucherIntegration || false,
        debit_note_account_name: debitNoteAccountName,
        debit_note_account_selection: debitNoteAccount,
        debit_note_discount_account_name: debitNoteDiscountAccountName,
        debit_note_discount_account_selection: debitNoteDiscountAccount,
        debit_note_roundoff_account_name: debitNoteRoundOffAccountName,
        debit_note_roundoff_account_selection: debitNoteRoundOffAccount,
        credit_note_account_name: creditNoteAccountName,
        credit_note_account_selection: creditNoteAccount,
        credit_note_discount_account_name: creditNoteDiscountAccountName,
        credit_note_discount_account_selection: creditNoteDiscountAccount,
        credit_note_roundoff_account_name: creditNoteRoundOffAccountName,
        credit_note_roundoff_account_selection: creditNoteRoundOffAccount,
        stock_journal_voucher_integration: stockJournalVoucherIntegration,
        debit_note_voucher_integration: debitNoteVoucherIntegration,
        create_purchase_product_in_base_uom: createPurchaseProductInBaseUOM,
        create_sales_product_in_base_uom: createSalesProductInBaseUOM,
        use_document_number_as_reference_number: useDocumentNumberAsReferenceNumberForInvoice,
        use_document_number_as_reference_number_for_bill: useDocumentNumberAsReferenceNumberForBill,
        use_invoice_date_as_voucher_date_in_bills: useInvoiceDateAsVoucherDateInBills,
      };
      connectTenantToTallyLocation(payload, () => {
        if (isDrawer) setShowDrawer(false);
        else setStep(stepNumber + 1);
      });
    } else {
      notification.error({
        message: 'Please select all mandatory fields',
        placement: 'top',
        duration: 4,
      });
    }
  };

  return (
    <div className="integration-step__wrapper tally-account-setup__wrapper" style={{ paddingBottom: '60px' }}>
      <div className="ant-row">
        <div className="ant-col-md-24">
          <Checkbox
            checked={salesVoucherIntegration}
            onChange={(value) => setSalesVoucherIntegration(value?.target?.checked)}
          >
            Sync sales vouchers
          </Checkbox>
        </div>
        <div className="ant-col-md-24">
          <Checkbox
            checked={purchaseVoucherIntegration}
            onChange={(value) => setPurchaseVoucherIntegration(value?.target?.checked)}
          >
            Sync purchase vouchers
          </Checkbox>
        </div>
        <div className="ant-col-md-24">
          <Checkbox
            checked={creditNoteVoucherIntegration}
            onChange={(value) => setCreditNoteVoucherIntegration(value?.target?.checked)}
          >
            Sync sales return vouchers
          </Checkbox>
        </div>
        <div className="ant-col-md-24">
          <Checkbox
            checked={debitNoteVoucherIntegration}
            onChange={(value) => setDebitNoteVoucherIntegration(value?.target?.checked)}
          >
            Sync purchase return vouchers
          </Checkbox>
        </div>
        <div className="ant-col-md-24">
          <Checkbox
            checked={stockJournalVoucherIntegration}
            onChange={(value) => setStockJournalVoucherIntegration(value?.target?.checked)}
          >
            Sync stock journal vouchers
          </Checkbox>
        </div>
        <div className="ant-col-md-24">
          <div className="ant-row">
            <div className={isPortrait ? "ant-col-md-24" : "ant-col-md-12"}>
              <div className="ant-row">
                <div className="ant-col-md-24 mg-top-15" style={{ fontWeight: '600', fontSize: '12px' }}>
                  Purchase Configuration
                </div>
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the purchase account in vendor receipts?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={purchaseAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setPurchaseAccount(value);
                        setSearchKeyword('');
                        setPurchaseAccountName('');
                      }}
                      style={{
                        border: '1px solid #E4E4E4',
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={purchaseAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {purchaseAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default purchase account" required className="integration-step-input__label" />
                      <PRZSelect
                        value={purchaseAccountName}
                        onChange={(value) => {
                          setPurchaseAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        className="integration-step-input__input"
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        showError={formSubmitted && purchaseVoucherIntegration && !purchaseAccountName && purchaseAccount == 'DEFAULT'}
                        errorName={"purchase option"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.purchase_account_list?.map((item) => <Option key={item.purchase_account_name} value={item.purchase_account_name}>{item.purchase_account_name}</Option>)}
                      </PRZSelect>
                    </div>
                  </div>
                )}

                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the purchase voucher in vendor receipts?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={purchaseVoucher}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setPurchaseVoucher(value);
                        setSearchKeyword('');
                        setPurchaseVoucherName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={voucherSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {purchaseVoucher === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default purchase voucher" required className="integration-step-input__label" />
                      <PRZSelect
                        value={purchaseVoucherName}
                        onChange={(value) => {
                          setPurchaseVoucherName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        className="integration-step-input__input"
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        showError={formSubmitted && purchaseVoucherIntegration && !purchaseVoucherName && purchaseVoucher == 'DEFAULT'}
                        errorName={"purchase option"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.voucher_types
                          ?.filter((item) => item.parent === 'Purchase')
                          .map((item) => (
                            <Option key={item.voucher_type_name} value={item.voucher_type_name}>
                              {item.voucher_type_name}
                            </Option>
                          ))}
                        {' '}

                      </PRZSelect>
                    </div>
                  </div>
                )}

                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the discount account in vendor receipts?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={purchaseDiscountAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setPurchaseDiscountAccount(value);
                        setSearchKeyword('');
                        setPurchaseDiscountAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={purchaseDiscountAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {purchaseDiscountAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default discount account for purchase" required className="integration-step-input__label" />
                      <PRZSelect
                        value={purchaseDiscountAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setPurchaseDiscountAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && purchaseVoucherIntegration && !purchaseDiscountAccountName && purchaseDiscountAccount === 'DEFAULT'}
                        errorName={"discount option"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.ledger_account_list?.map((item) => <Option key={item?.account_id} value={item?.ledger_account_name}>{item?.ledger_account_name}</Option>)}

                      </PRZSelect>
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the roundoff account in vendor receipts?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={purchaseRoundOffAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setPurchaseRoundOffAccount(value);
                        setSearchKeyword('');
                        setPurchaseRoundOffAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={purchaseRoundOffAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {purchaseRoundOffAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default roundoff account for purchase" required className="integration-step-input__label" />
                      <PRZSelect
                        value={purchaseRoundOffAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setPurchaseRoundOffAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && purchaseVoucherIntegration && !purchaseRoundOffAccountName && purchaseRoundOffAccount === 'DEFAULT'}
                        errorName={"roundoff option"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.roundoff_account_list?.map((item) => <Option key={item.roundoff_account_name} value={item.roundoff_account_name}>{item.roundoff_account_name}</Option>)}

                      </PRZSelect>
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the freight account in vendor receipts?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={purchaseFreightAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setPurchaseFreightAccount(value);
                        setSearchKeyword('');
                        setPurchaseFreightAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={purchaseFreightAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {purchaseFreightAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default freight account for purchase" required className="integration-step-input__label" />
                      <PRZSelect
                        value={purchaseFreightAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setPurchaseFreightAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !purchaseVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && purchaseVoucherIntegration && !purchaseFreightAccountName && purchaseFreightAccount === 'DEFAULT'}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.ledger_account_list?.map((item) => <Option key={item?.account_id} value={item?.ledger_account_name}>{item?.ledger_account_name}</Option>)}

                      </PRZSelect>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={isPortrait ? "ant-col-md-24" : "ant-col-md-12"}>
              <div className="ant-row">
                <div className="ant-col-md-24 mg-top-15" style={{ fontWeight: '600', fontSize: '12px' }}>
                  Debit Note Configuration
                </div>
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the purchase return account?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={debitNoteAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setDebitNoteAccount(value);
                        setSearchKeyword('');
                        setDebitNoteAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={debitNoteAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !debitNoteVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {debitNoteAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default purchase return account" required className="integration-step-input__label" />
                      <PRZSelect
                        value={debitNoteAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setDebitNoteAccountName(value);
                          setSearchKeyword('');
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !debitNoteVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && debitNoteVoucherIntegration && !debitNoteAccountName && debitNoteAccount === 'DEFAULT'}
                        errorName={"purchase account"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.purchase_account_list?.map((item) => <Option key={item.purchase_account_name} value={item.purchase_account_name}>{item.purchase_account_name}</Option>)}
                      </PRZSelect>
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the discount account for purchase return?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={debitNoteDiscountAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setDebitNoteDiscountAccount(value);
                        setSearchKeyword('');
                        setDebitNoteDiscountAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={purchaseDiscountAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !debitNoteVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {debitNoteDiscountAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default discount account for purchase return" required className="integration-step-input__label" />
                      <PRZSelect
                        value={debitNoteDiscountAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setDebitNoteDiscountAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !debitNoteVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && debitNoteVoucherIntegration && !debitNoteDiscountAccountName && debitNoteDiscountAccount === 'DEFAULT'}
                        errorName={"discount option"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.ledger_account_list?.map((item) => <Option key={item?.account_id} value={item?.ledger_account_name}>{item?.ledger_account_name}</Option>)}

                      </PRZSelect>
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the roundoff account for purchase return?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={debitNoteRoundOffAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setDebitNoteRoundOffAccount(value);
                        setSearchKeyword('');
                        setDebitNoteRoundOffAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={purchaseRoundOffAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !debitNoteVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {debitNoteRoundOffAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default roundoff account for purchase return" required className="integration-step-input__label" />
                      <PRZSelect
                        value={debitNoteRoundOffAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setDebitNoteRoundOffAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !debitNoteVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && debitNoteVoucherIntegration && !debitNoteRoundOffAccountName && debitNoteRoundOffAccount === 'DEFAULT'}
                        errorName={"roundoff opion"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.roundoff_account_list?.map((item) => <Option key={item.roundoff_account_name} value={item.roundoff_account_name}>{item.roundoff_account_name}</Option>)}

                      </PRZSelect>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={isPortrait ? "ant-col-md-24" : "ant-col-md-12"}>
              <div className="ant-row">
                <div className="ant-col-md-24 mg-top-15" style={{ fontWeight: '600', fontSize: '12px' }}>
                  Sales Configuration
                </div>
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the sales account in invoices?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={sellerAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setSellerAccount(value);
                        setSearchKeyword('');
                        setSellerOption('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={salesAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {sellerAccount == 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default sales account" required className="integration-step-input__label" />
                      <PRZSelect
                        value={sellerOption}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setSellerOption(value);
                          setSearchKeyword('');
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && salesVoucherIntegration && !sellerOption && sellerAccount == 'DEFAULT'}
                        errorName={"sales account"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.sales_account_list?.map((item) => <Option key={item.sales_account_name} value={item.sales_account_name}>{item.sales_account_name}</Option>)}
                      </PRZSelect>
                      {formSubmitted && salesVoucherIntegration && !sellerOption && sellerAccount == 'DEFAULT' && (
                        <div className="input-error">
                          *Please enter sales account
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the sales voucher in vendor receipts?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={salesVoucher}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setSalesVoucher(value);
                        setSearchKeyword('');
                        setSalesVoucherName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={voucherSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {salesVoucher == 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default sales voucher" required className="integration-step-input__label" />
                      <PRZSelect
                        value={salesVoucherName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setSalesVoucherName(value);
                          setSearchKeyword('');
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && salesVoucherIntegration && !salesVoucherName && salesVoucher == 'DEFAULT'}
                        errorName={"sales voucher type"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.voucher_types
                          ?.filter((item) => item.parent === 'Sales')
                          .map((item) => (
                            <Option key={item.voucher_type_name} value={item.voucher_type_name}>
                              {item.voucher_type_name}
                            </Option>
                          ))}
                      </PRZSelect>
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the discount account in customer receipts?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={salesDiscountAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setSalesDiscountAccount(value);
                        setSearchKeyword('');
                        setSalesDiscountAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={salesDiscountAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {salesDiscountAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default discount account for sales" required className="integration-step-input__label" />
                      <PRZSelect
                        value={salesDiscountAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setSalesDiscountAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && salesVoucherIntegration && !salesDiscountAccountName && salesDiscountAccount === 'DEFAULT'}
                        errorName={"discount option"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.ledger_account_list?.map((item) => <Option key={item?.account_id} value={item?.ledger_account_name}>{item?.ledger_account_name}</Option>)}

                      </PRZSelect>
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the roundoff account in customer receipts?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={salesRoundOffAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setSalesRoundOffAccount(value);
                        setSearchKeyword('');
                        setSalesRoundOffAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={salesRoundOffAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {salesRoundOffAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default roundoff account for sales" required className="integration-step-input__label" />
                      <PRZSelect
                        value={salesRoundOffAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setSalesRoundOffAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && salesVoucherIntegration && !salesRoundOffAccountName && salesRoundOffAccount === 'DEFAULT'}
                        errorName={"roundoff option"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.roundoff_account_list?.map((item) => <Option key={item.roundoff_account_name} value={item.roundoff_account_name}>{item.roundoff_account_name}</Option>)}

                      </PRZSelect>
                      {formSubmitted && salesVoucherIntegration && !salesRoundOffAccountName && salesRoundOffAccount === 'DEFAULT' && (
                        <div className="input-error">
                          *Please select roundoff option
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the freight account in customer receipts?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={salesFreightAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setSalesFreightAccount(value);
                        setSearchKeyword('');
                        setSalesFreightAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={salesFreightAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {salesFreightAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default freight account for sales" required className="integration-step-input__label" />
                      <PRZSelect
                        value={salesFreightAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setSalesFreightAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !salesVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && salesVoucherIntegration && !salesFreightAccountName && salesFreightAccount === 'DEFAULT'}
                        errorName={"freight account"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.ledger_account_list?.map((item) => <Option key={item?.account_id} value={item?.ledger_account_name}>{item?.ledger_account_name}</Option>)}

                      </PRZSelect>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={isPortrait ? "ant-col-md-24" : "ant-col-md-12"}>
              <div className="ant-row">
                <div className="ant-col-md-24 mg-top-15" style={{ fontWeight: '600', fontSize: '12px' }}>
                  Credit Note Configuration
                </div>
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the sales return account?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={creditNoteAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setCreditNoteAccount(value);
                        setSearchKeyword('');
                        setCreditNoteAccountName('');
                      }}
                      style={{
                        width: isDrawer ? '90%' : '30%',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={creditNoteAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !creditNoteVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {creditNoteAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default sales return account" required className="integration-step-input__label" />
                      <PRZSelect
                        value={creditNoteAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setCreditNoteAccountName(value);
                          setSearchKeyword('');
                        }}
                        style={{
                          width: isDrawer ? '90%' : '30%',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !creditNoteVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && creditNoteVoucherIntegration && !creditNoteAccountName && creditNoteAccount === 'DEFAULT'}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.sales_account_list?.map((item) => <Option key={item.sales_account_name} value={item.sales_account_name}>{item.sales_account_name}</Option>)}
                      </PRZSelect>
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the discount account for sales return?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={creditNoteDiscountAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setCreditNoteDiscountAccount(value);
                        setSearchKeyword('');
                        setCreditNoteDiscountAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={salesDiscountAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !creditNoteVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {creditNoteDiscountAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default discount account for sales return" required className="integration-step-input__label" />
                      <PRZSelect
                        value={creditNoteDiscountAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setCreditNoteDiscountAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !creditNoteVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && creditNoteVoucherIntegration && !creditNoteDiscountAccountName && creditNoteDiscountAccount === 'DEFAULT'}
                        errorName={"discount option"}
                        errorClassName={"input-error"}
                      >
                        {data?.[0]?.ledger_account_list?.map((item) => <Option key={item?.account_id} value={item?.ledger_account_name}>{item?.ledger_account_name}</Option>)}

                      </PRZSelect>
                    </div>
                  </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the roundoff account for sales return?" required className="integration-step-input__label" />
                    <PRZSelect
                      value={creditNoteRoundOffAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setCreditNoteRoundOffAccount(value);
                        setSearchKeyword('');
                        setCreditNoteRoundOffAccountName('');
                      }}
                      style={{
                        borderRadius: '2px',
                        height: '28px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={salesRoundOffAccountSelectionMethod}
                      disabled={connectTenantToTallyLocationLoading || !creditNoteVoucherIntegration}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {creditNoteRoundOffAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                    <div className="integration-step-input__wrapper">
                      <H3Text text="Please select a default roundoff account for sales return" required className="integration-step-input__label" />
                      <PRZSelect
                        value={creditNoteRoundOffAccountName}
                        showSearch
                        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          setCreditNoteRoundOffAccountName(value);
                        }}
                        style={{
                          borderRadius: '2px',
                          height: '28px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        disabled={connectTenantToTallyLocationLoading || !creditNoteVoucherIntegration}
                        className="integration-step-input__input"
                        showError={formSubmitted && creditNoteVoucherIntegration && !creditNoteRoundOffAccountName && creditNoteRoundOffAccount === 'DEFAULT'}
                        errorClassName={"input-error"}
                        errorName={"roundoff option"}
                      >
                        {data?.[0]?.roundoff_account_list?.map((item) => <Option key={item.roundoff_account_name} value={item.roundoff_account_name}>{item.roundoff_account_name}</Option>)}

                      </PRZSelect>
                    </div>
                  </div>
                )}
            {/* <div className={isPortrait ? "ant-col-md-24" : "ant-col-md-12"} /> */}
          </div>
          <div className="ant-row">

            {/* <div className={isPortrait ? "ant-col-md-24" : "ant-col-md-12"}>
              <div className="ant-row">
                <div className="ant-col-md-24 mg-top-15" style={{ fontWeight: '600', fontSize: '12px' }}>
                  Purchase Configuration
                </div>
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the purchase account in vendor receipts?" required className="integration-step-input__label" />
                    <Select
                      value={purchaseAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setPurchaseAccount(value);
                        setSearchKeyword('');
                        setPurchaseAccountName('');
                      }}
                      style={{
                        border: '1px solid rgba(45, 125, 247, 0.25)',
                        borderRadius: '2px',
                        height: '32px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={purchaseAccountSelectionMethod}
                      bordered={false}
                      disabled={connectTenantToTallyLocationLoading}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {purchaseAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="Please select a default purchase account" required className="integration-step-input__label" />
                    <Select
                      value={purchaseAccountName}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setPurchaseAccountName(value);
                      }}
                      size="small"
                      style={{
                        border: '1px solid rgba(45, 125, 247, 0.25)',
                        borderRadius: '2px',
                        height: '32px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      className="integration-step-input__input"
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      bordered={false}
                      disabled={connectTenantToTallyLocationLoading}
                    >
                      {data?.[0]?.purchase_account_list?.map((item) => <Option key={item.purchase_account_name} value={item.purchase_account_name}>{item.purchase_account_name}</Option>)}
                    </Select>
                    {formSubmitted && !purchaseAccountName && purchaseAccount == 'DEFAULT' && (
                      <div className="input-error">
                        *Please enter purchase option
                      </div>
                    )}
                  </div>
                </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the discount account in vendor receipts?" required className="integration-step-input__label" />
                    <Select
                      value={purchaseDiscountAccount}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setPurchaseDiscountAccount(value);
                        setSearchKeyword('');
                        setPurchaseDiscountAccountName('');
                      }}
                      style={{
                        border: '1px solid rgba(45, 125, 247, 0.25)',
                        borderRadius: '2px',
                        height: '32px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      options={purchaseDiscountAccountSelectionMethod}
                      bordered={false}
                      disabled={connectTenantToTallyLocationLoading}
                      className="integration-step-input__input"
                    />
                  </div>
                </div>
                {purchaseDiscountAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="Please select a default discount account for purchase" required className="integration-step-input__label" />
                    <Select
                      value={purchaseDiscountAccountName}
                      showSearch
                      filterOption={false}
                      onChange={(value) => {
                        setPurchaseDiscountAccountName(value);
                      }}
                      size="small"
                      style={{
                        border: '1px solid rgba(45, 125, 247, 0.25)',
                        borderRadius: '2px',
                        height: '32px',
                        width: isDrawer ? '90%' : '30%',
                        fontSize: '13px',
                        margin: '0px 0px',
                      }}
                      onSearch={(value) => {
                        setSearchKeyword(value);
                      }}
                      bordered={false}
                      disabled={connectTenantToTallyLocationLoading}
                      className="integration-step-input__input"
                    >
                      {data?.[0]?.ledger_account_list?.map((item) => <Option key={item.discount_account_name} value={item.discount_account_name}>{item.discount_account_name}</Option>)}

                    </Select>
                    {formSubmitted && !purchaseDiscountAccountName && purchaseDiscountAccount === 'DEFAULT' && (
                      <div className="input-error">
                        *Please enter discount option
                      </div>
                    )}
                  </div>
                </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the roundoff account in vendor receipts?" required className="integration-step-input__label" />
                      <Select
                        value={purchaseRoundOffAccount}
                        showSearch
                        filterOption={false}
                        onChange={(value) => {
                          setPurchaseRoundOffAccount(value);
                          setSearchKeyword('');
                          setPurchaseRoundOffAccountName('');
                        }}
                        style={{
                          border: '1px solid rgba(45, 125, 247, 0.25)',
                          borderRadius: '2px',
                          height: '32px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        options={purchaseRoundOffAccountSelectionMethod}
                        bordered={false}
                        disabled={connectTenantToTallyLocationLoading}
                        className="integration-step-input__input"
                      />
                  </div>
                </div>
                {purchaseRoundOffAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="Please select a default roundoff account for purchase" required className="integration-step-input__label" />
                      <Select
                        value={purchaseRoundOffAccountName}
                        showSearch
                        filterOption={false}
                        onChange={(value) => {
                          setPurchaseRoundOffAccountName(value);
                        }}
                        size="small"
                        style={{
                          border: '1px solid rgba(45, 125, 247, 0.25)',
                          borderRadius: '2px',
                          height: '32px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        bordered={false}
                        disabled={connectTenantToTallyLocationLoading}
                        className="integration-step-input__input"
                      >
                        {data?.[0]?.roundoff_account_list?.map((item) => <Option key={item.roundoff_account_name} value={item.roundoff_account_name}>{item.roundoff_account_name}</Option>)}

                      </Select>
                      {formSubmitted && !purchaseRoundOffAccountName && purchaseRoundOffAccount === 'DEFAULT' && (
                        <div className="input-error">
                          *Please select roundoff option
                        </div>
                      )}
                  </div>
                </div>
                )}
                <div className="ant-col-md-24">
                  <div className="integration-step-input__wrapper">
                    <H3Text text="How will you select the freight account in vendor receipts?" required className="integration-step-input__label" />
                      <Select
                        value={purchaseFreightAccount}
                        showSearch
                        filterOption={false}
                        onChange={(value) => {
                          setPurchaseFreightAccount(value);
                          setSearchKeyword('');
                          setPurchaseFreightAccountName('');
                        }}
                        style={{
                          border: '1px solid rgba(45, 125, 247, 0.25)',
                          borderRadius: '2px',
                          height: '32px',
                          width: isDrawer ? '90%' : '30%',
                          fontSize: '13px',
                          margin: '0px 0px',
                        }}
                        onSearch={(value) => {
                          setSearchKeyword(value);
                        }}
                        options={purchaseFreightAccountSelectionMethod}
                        bordered={false}
                        disabled={connectTenantToTallyLocationLoading}
                        className="integration-step-input__input"
                      />
                  </div>
                </div>
                {purchaseFreightAccount === 'DEFAULT' && (
                  <div className="ant-col-md-24">
                      <div className="integration-step-input__wrapper">
                        <H3Text text="Please select a default freight account for purchase" required className="integration-step-input__label" />
                          <Select
                            value={purchaseFreightAccountName}
                            showSearch
                            filterOption={false}
                            onChange={(value) => {
                              setPurchaseFreightAccountName(value);
                            }}
                            size="small"
                            style={{
                              border: '1px solid rgba(45, 125, 247, 0.25)',
                              borderRadius: '2px',
                              height: '32px',
                              width: isDrawer ? '90%' : '30%',
                              fontSize: '13px',
                              margin: '0px 0px',
                            }}
                            onSearch={(value) => {
                              setSearchKeyword(value);
                            }}
                            bordered={false}
                            disabled={connectTenantToTallyLocationLoading}
                            className="integration-step-input__input"
                          >
                            {data?.[0]?.ledger_account_list?.map((item) => <Option key={item.discount_account_name} value={item.discount_account_name}>{item.discount_account_name}</Option>)}

                          </Select>
                          {formSubmitted && !purchaseFreightAccountName && purchaseFreightAccount === 'DEFAULT' && (
                            <div className="input-error">
                              *Please select freight account
                            </div>
                          )}
                      </div>
                  </div>
                )}
              </div>
            </div> */}
          </div>
            </div>
            <div className={isPortrait ? "ant-col-md-24" : "ant-col-md-12"}>
              <div className='ant-row'>
                <div className="ant-col-md-24 mg-top-15" style={{ fontWeight: '600', fontSize: '12px', marginBottom: '10px', }}>
                  Additional Configuration
                </div>
                <div className="ant-col-md-24">
                  <Checkbox
                    checked={createPurchaseProductInBaseUOM}
                    onChange={(value) => setCreatePurchaseProductInBaseUOM(value?.target?.checked)}
                  >
                    Create purchase product in base UOM
                    &nbsp;
                    <Tooltip
                      title={
                        <div>When bill is pushed from Procuzy to Tally, if product does not exist it will create product using inventory UOM if configuration is true, otherwise it will create product using document UOM</div>
                      }
                      placement='right'
                    >
                      <FontAwesomeIcon icon={faCircleInfo} style={{ color: '#2d7df7', }}/>
                    </Tooltip>
                  </Checkbox>
                </div>
                <div className="ant-col-md-24">
                  <Checkbox
                    checked={createSalesProductInBaseUOM}
                    onChange={(value) => setCreateSalesProductInBaseUOM(value?.target?.checked)}
                  >
                    Create sales product in base UOM
                    &nbsp;
                    <Tooltip
                      title={
                        <div>When Invoice/Credit Note is pushed from Procuzy to Tally, if product does not exist it will create product using inventory UOM if configuration is true, otherwise it will create product using document UOM</div>
                      }
                      placement='right'
                    >
                      <FontAwesomeIcon icon={faCircleInfo} style={{ color: '#2d7df7', }}/>
                    </Tooltip>
                  </Checkbox>
                </div>
                <div className="ant-col-md-24">
                  <Checkbox
                    checked={useDocumentNumberAsReferenceNumberForInvoice}
                    onChange={(value) => setUseDocumentNumberAsReferenceNumberForInvoice(value?.target?.checked)}
                  >
                    Use document number as reference number in sales invoice
                  </Checkbox>
                </div>
                <div className="ant-col-md-24">
                  <Checkbox
                    checked={useDocumentNumberAsReferenceNumberForBill}
                    onChange={(value) => setUseDocumentNumberAsReferenceNumberForBill(value?.target?.checked)}
                  >
                    Use document number as reference number in bill
                  </Checkbox>
                </div>
                <div className="ant-col-md-24">
                  <Checkbox
                    checked={useInvoiceDateAsVoucherDateInBills}
                    onChange={(value) => setUseInvoiceDateAsVoucherDateInBills(value?.target?.checked)}
                  >
                    Use invoice date as voucher date in bills
                  </Checkbox>
                </div>
              </div>
            </div>
        <div className="ant-row integration-step__footer" style={{ display: 'flex', marginTop: '20px', paddingTop: '10px' }}>
          {!isDrawer
            && (
              <Button type="primary" onClick={() => setStep(2)} disabled={connectTenantToTallyLocationLoading} ghost>
                Back
              </Button>
            )}
          &nbsp;&nbsp;
          <Button type="primary" onClick={() => handleSubmit()} disabled={connectTenantToTallyLocationLoading}>
            {!isDrawer ? 'Save and Continue' : 'Update'}
          </Button>
        </div>
      </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducers, TenantReducers, TallyIntegrationReducers }) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  tallyConnections: TallyIntegrationReducers.tallyConnections,
  connectTenantToTallyLocationLoading: TallyIntegrationReducers.connectTenantToTallyLocationLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getTallyConnections: (orgId, callback) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback)),
  connectTenantToTallyLocation: (payload, callback) => dispatch(TallyIntegrationActions.connectTenantToTallyLocation(payload, callback)),
});

AccountSetup.propTypes = {
  user: PropTypes.any,
  getTenants: PropTypes.func,
  getTallyConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  tenants: PropTypes.any,
  getTallyConnections: PropTypes.func,
  connectTenantToTallyLocation: PropTypes.func,
  connectTenantToTallyLocationLoading: PropTypes.bool,
  tallyConnection: PropTypes.any,
  setStep: PropTypes.func,
  stepNumber: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountSetup));
